import { render, staticRenderFns } from "./SurveyQuestionViewer.vue?vue&type=template&id=853c7264&scoped=true"
import script from "./SurveyQuestionViewer.vue?vue&type=script&lang=js"
export * from "./SurveyQuestionViewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "853c7264",
  null
  
)

export default component.exports